// extracted by mini-css-extract-plugin
export default {"container":"director_container__Yv7wO","directorcontainer":"director_directorcontainer__5YX6f","img":"director_img__98IjL","el1":"director_el1__Huer1","el2":"director_el2__06APR"};